import React from "react";

const LOGO_URL =
  "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/logo%2FM2T-brandlogo-whitebg-3000x80.png?alt=media&token=61a23fff-4b9a-44ef-bf35-be3966f6ee48";

export default function M2TLogo({ className = "h-12" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Million2Trillion Logo"
      className={`h-full w-auto object-contain ${className}`}
      loading="eager"
    />
  );
}
